import { PcbNodeTypes, } from "@buildwithflux/models";
import { convertLength } from "@buildwithflux/shared";
import SparkMD5 from "spark-md5";
export class AutoLayoutHelpers {
    static autoLayoutNodeUidPrefix = "autoLayout";
    static createNodeObjectUid(nodeData) {
        let nodeType;
        const hashData = [];
        switch (nodeData.type) {
            case PcbNodeTypes.routeSegment: {
                const data = nodeData;
                nodeType = "Trace";
                hashData.push(data.netUid, data.layerId, data.startPosition.x, data.startPosition.y, data.endPosition.x, data.endPosition.y, data.width);
                break;
            }
            case PcbNodeTypes.smartVia: {
                const data = nodeData;
                nodeType = "SmartVia";
                hashData.push(data.netUid, data.position.x, data.position.y, data.viaConfigUid);
                break;
            }
        }
        const hash = SparkMD5.hash(hashData.join("|"));
        const uid = [this.autoLayoutNodeUidPrefix, nodeData.netUid, nodeType, hash].join(".");
        return uid;
    }
    static nmToM(nm) {
        return convertLength(nm, "nm", "m");
    }
    static pointToXY(point) {
        return {
            x: this.nmToM(point[0]),
            y: this.nmToM(point[1]),
        };
    }
}
//# sourceMappingURL=AutoLayoutHelpers.js.map